import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authenticatedActivateChildGuard: CanActivateChildFn = (route, state) => {
	const oauthService = inject(OAuthService);
	if (oauthService.hasValidIdToken()) {
		return true;
	}
	oauthService.initLoginFlow();
	return false;
};
